/* eslint-disable indent */
import React from 'react';
import Pagination from 'react-js-pagination';
import Li from '../Li/Li';
import Filters from '../Filters';
import AddNewLi from '../Li/AddNewLi';
//import UsersExport from '../Exports/Users/UsersExport';

export const UsersPageComponent = props => (
	<div>
		<Filters
			searchOnChange={props.searchOnChange}
			searchable={[props.users]}
			multiSelectBoxes={[
				{
					label: 'Role Type',
					filterClass: 'roleGroup',
					items: JSON.parse(localStorage.getItem("isSuperman")) || false ?  props.roles.map(e => { return { id: e, name: e }; }) : props.roles.map(e => { return { id: e, name: e }; }).filter(e => e.name !== "Superman"),
					onChange: props.handleRoleFilter,
				},
				
			]}
			Dropdowns={[
				{
					label: 'User Group',
					filterClass: 'userGroupSelect',
					items: props.userGroups,
					onChange: props.handleUserGroupFilter,
				},

				
				{
					activeDropdown: true,
					label: 'Active Users',
					filterClass: 'userGroupSelect',
					items: [{ id: 1, name: "Active" }, { id: 0, name: "InActive" }, { id: 2, name: "All Users", selected: true }],
					onChange: props.handleIsActiveFilter
				}
			]}
			RoomDisplayToggle={[
								
			]}
	
		/>
	
		<div className="rightSideContent">
			<AddNewLi mainDesc="Add New User" RouteKey="users" />
			<Li
				userLi
				onClick={props.scheduleFetch}
				nameKey={"userName"}
				LiList={
					{
						userLi: true,
						linkKey: 'users',
						liClass: 'liListClass',
						
						// notes: props.filteredData.length ? props.filteredData.slice((props.activePage - 1) * 10, props.activePage * 10) : props.filteredData,
						items: props.filteredData.length ? props.filteredData.slice((props.activePage - 1) * 10, props.activePage * 10) : props.filteredData,
						deleteClick: props.deleteClick,
					}
				}
			/>
			
			<div className="paginationWrapper">
				{props.filteredData.length <= 10 ? '' : <Pagination
					hideDisabled
					prevPageText="prev"
					nextPageText="next"
					firstPageText="first"
					lastPageText="last"
					activePage={props.activePage}
					itemsCountPerPage={10}
					totalItemsCount={props.filteredData.length}
					onChange={props.handlePageChange}
				/>}
			</div>
		</div>
		
	</div>

);



// WEBPACK FOOTER //
// ./src/Components/Pages/UsersPageComponent.js